"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const values_1 = __importDefault(require("lodash/values"));
const joi_1 = __importDefault(require("joi"));
const joi_phone_number_1 = __importDefault(require("joi-phone-number"));
const date_1 = __importDefault(require("@joi/date"));
const extendedJoi = joi_1.default.extend(joi_phone_number_1.default, date_1.default);
const utils_1 = require("../../utils");
const defaults_1 = require("../defaults");
const constants_1 = require("../constants");
const labels_1 = require("../labels");
const LIMITS = __importStar(require("../limits"));
const isValid = (value, schema) => {
    const { error } = schema.validate(value);
    return !error;
};
// generic validation logic for measurements with two possible units (metric/imperial) - for Length and Weight
const measurementValidation = (measurementType, limitsObj) => {
    const keys = (0, utils_1.lowercaseKeys)(measurementType);
    if (keys.length !== 2)
        throw new Error(`${measurementType} must have exactly two keys`);
    const [metricUnit, imperialUnit] = keys; // e.g., [cm, in] or [kg, lb]
    const [metricLimit, imperialLimit] = [limitsObj[metricUnit], limitsObj[imperialUnit]];
    if (!metricLimit || !imperialLimit)
        throw new Error(`${measurementType} must have limits for both metric and imperial units`);
    return joi_1.default.object({
        unit: joi_1.default
            .string()
            .lowercase()
            .valid(...(0, utils_1.lowercaseKeys)(measurementType))
            .required(),
        value: joi_1.default.when(joi_1.default.ref("unit"), {
            is: metricUnit,
            then: joi_1.default.number().min(metricLimit.min).max(metricLimit.max).required(),
            otherwise: joi_1.default.number().min(imperialLimit.min).max(imperialLimit.max).required(),
        }),
    });
};
// converts the measurementObj from {unit, value} to {metricUnit: value, imperialUnit: value}
// meant to be used with the joi.custom() function - for Length and Weight
const measurementConversion = (measurementType) => (measurementObj, helpers) => {
    const modifiedValue = {};
    const { unit, value: rawValue } = measurementObj;
    const keys = (0, utils_1.lowercaseKeys)(measurementType);
    if (keys.length !== 2)
        throw new Error(`${measurementType} must have exactly two keys`);
    const [metricUnit, imperialUnit] = keys; // e.g., [cm, in] or [kg, lb]
    if (unit === metricUnit) {
        modifiedValue[metricUnit] = rawValue;
        modifiedValue[imperialUnit] = (0, utils_1.unitConversionMap)(metricUnit, rawValue);
    }
    else {
        modifiedValue[imperialUnit] = rawValue;
        modifiedValue[metricUnit] = (0, utils_1.unitConversionMap)(imperialUnit, rawValue);
    }
    return modifiedValue;
};
// converts the string input to a UnitPreference object
const unitPreferenceConversion = (value, helpers) => {
    if ((0, utils_1.lowercaseComparison)(value, (0, values_1.default)(constants_1.Unit))) {
        return (0, utils_1.getUnitPreference)(value);
    }
    return (0, defaults_1.getDefaultUnitPreference)();
};
// validate a string value against multiple possible options
const selectOneFromOptionsValidation = (options) => 
// eslint-disable-next-line prettier/prettier
joi_1.default.string().lowercase().valid(...(0, utils_1.lowercaseKeys)(options));
// validate an Array<str> against multiple possible options
const selectMultipleFromOptionsValidation = (options) => 
// eslint-disable-next-line prettier/prettier
joi_1.default.array().items(joi_1.default.string().lowercase().valid(...(0, utils_1.lowercaseKeys)(options)));
const stringWithLengthValidation = (min, max, allowEmpty = false) => allowEmpty ? joi_1.default.string().min(min).max(max).allow("") : joi_1.default.string().min(min).max(max);
module.exports = {
    email: joi_1.default
        .string()
        .lowercase()
        .email({ tlds: { allow: false } }),
    password: joi_1.default.string().min(LIMITS.password.min).max(LIMITS.password.max).pattern(LIMITS.password.regex),
    username: joi_1.default
        .string()
        .lowercase()
        .min(LIMITS.username.min)
        .max(LIMITS.username.max)
        .trim()
        .pattern(LIMITS.username.regex),
    name: joi_1.default.string().min(LIMITS.name.min).max(LIMITS.name.max).trim().pattern(LIMITS.name.regex),
    url: joi_1.default.string().uri(),
    postPrivacy: selectOneFromOptionsValidation(constants_1.PostPrivacy),
    location: joi_1.default
        .object({
        city: joi_1.default.string().lowercase().required(),
        countryCode: joi_1.default.string().lowercase().required(),
        countryName: joi_1.default.string().lowercase().required(),
        IPV4: joi_1.default.string().ip({ version: ["ipv4", "ipv6"] }),
        latitude: joi_1.default.number().min(-90).max(90),
        longitude: joi_1.default.number().min(-180).max(180),
        postalCode: joi_1.default.string(),
        state: joi_1.default.string().lowercase(),
    })
        .unknown(true),
    unitPreference: joi_1.default.string().lowercase().custom(unitPreferenceConversion),
    bio: joi_1.default.string().min(LIMITS.bio.min).max(LIMITS.bio.max).trim(),
    socialMediaAccounts: (allowEmpty = false) => {
        const schema = joi_1.default.object({
            twitter: stringWithLengthValidation(LIMITS.socialMediaUsername.twitter.min, LIMITS.socialMediaUsername.twitter.max, allowEmpty),
            facebook: stringWithLengthValidation(LIMITS.socialMediaUsername.facebook.min, LIMITS.socialMediaUsername.facebook.max, allowEmpty),
            instagram: stringWithLengthValidation(LIMITS.socialMediaUsername.instagram.min, LIMITS.socialMediaUsername.instagram.max, allowEmpty),
            tiktok: stringWithLengthValidation(LIMITS.socialMediaUsername.tiktok.min, LIMITS.socialMediaUsername.tiktok.max, allowEmpty),
        });
        return allowEmpty ? schema.allow("") : schema;
    },
    phoneNumber: extendedJoi.string().phoneNumber({ format: defaults_1.defaultPhoneNumberFormat }),
    token: joi_1.default.string().token(),
    // TODO: implement a better way to validate date strings (e.g., extendedJoi.date().format(defaultDateFormat))
    date: joi_1.default.string(),
    percentage: joi_1.default.number().min(0).max(100),
    count: joi_1.default.number().min(0),
    title: stringWithLengthValidation(LIMITS.title.min, LIMITS.title.max).trim(),
    gender: selectOneFromOptionsValidation(constants_1.Gender),
    height: measurementValidation(constants_1.Length, LIMITS.height).custom(measurementConversion(constants_1.Length)),
    bodyWeight: measurementValidation(constants_1.Weight, LIMITS.bodyWeight).custom(measurementConversion(constants_1.Weight)),
    exerciseWeight: measurementValidation(constants_1.Weight, LIMITS.exerciseWeight).custom(measurementConversion(constants_1.Weight)),
    bodySize: measurementValidation(constants_1.Length, LIMITS.bodySize).custom(measurementConversion(constants_1.Length)),
    exerciseTime: joi_1.default.number().min(LIMITS.exerciseTime[constants_1.Time.SECS].min).max(LIMITS.exerciseTime[constants_1.Time.SECS].max),
    goal: selectOneFromOptionsValidation(labels_1.goalLabels),
    diets: selectMultipleFromOptionsValidation(labels_1.dietLabels),
    activities: selectMultipleFromOptionsValidation(labels_1.activityLabels),
    supplements: selectMultipleFromOptionsValidation(labels_1.supplementLabels),
    trackedMetrics: selectMultipleFromOptionsValidation(labels_1.allTrackableMeasurementsLabels),
    measurementValidation,
    measurementConversion,
    selectOneFromOptionsValidation,
    selectMultipleFromOptionsValidation,
    isValid,
};
//# sourceMappingURL=common.js.map